module.exports = __webpack_public_path__ + "img/it-service-02.3562229f.webp";